import script from "./DeveloperView.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperView.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperView.vue?vue&type=style&index=0&id=70174031&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70174031"]])

export default __exports__